// Zone recalculation writes both roofZone and edgeType. The tech-upgrade
// UPDATE_PANELS(..., { type: 'roofZone' }) path used to copy only roofZone,
// which dropped E/R/N labels after every add/load.
export function getPanelUpdatePatch(foundPanel: panelInState, updateType?: string) {
  if (updateType === 'roofZone') {
    return {
      roofZone: foundPanel.roofZone,
      edgeType: foundPanel.edgeType,
    };
  }
  if (updateType) {
    return { [updateType]: foundPanel[updateType] };
  }
  return foundPanel;
}
